import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, {
	type srcAsyncEditIssueTypeQuery$variables,
} from './src/__generated__/srcAsyncEditIssueTypeQuery.graphql';

export const asyncEditIssueTypeModalEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-edit-issue-type-modal-entrypoint" */ './src').then(
			(module) => module.AsyncEditIssueTypeModal,
		),
	),
	getPreloadProps: ({ projectKey, cloudId }: srcAsyncEditIssueTypeQuery$variables) => ({
		queries: {
			editIssueTypeModal: {
				options: { fetchPolicy: 'store-and-network' as const },
				parameters,
				variables: { projectKey, cloudId },
			},
		},
	}),
});
